import { Users, Sparkles, Camera, Heart } from "lucide-react";
import { BENEFITS } from "../../data/experiences";
import { Reveal, Eyebrow } from "./Reveal";

const ICONS = { Users, Sparkles, Camera, Heart };

export default function WhyCommunities() {
  return (
    <section className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14 md:mb-20">
          <Reveal>
            <Eyebrow>Why Communities Love It</Eyebrow>
            <h2 className="mt-5 font-poppins font-bold text-charcoal text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight">
              A little joy goes a long way.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {BENEFITS.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.title} delay={(i % 2) * 0.08}>
                <div
                  data-testid={`why-card-${i}`}
                  className="h-full rounded-[1.75rem] bg-white border border-border p-8 md:p-10 transition-all hover:-translate-y-1.5 hover:shadow-[0_28px_55px_-28px_rgba(73,53,72,0.25)]"
                >
                  <div className="h-14 w-14 rounded-2xl bg-coral/12 grid place-items-center mb-6">
                    <Icon size={28} strokeWidth={1.6} className="text-coral" />
                  </div>
                  <h3 className="font-poppins font-bold text-2xl text-charcoal leading-snug">{item.title}</h3>
                  <p className="mt-3 text-lg text-charcoal/70 leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
